import { GROUP_NAME_TEXT, Group, GroupName } from "@/types/group";
import { User } from "@/types/user";

export const normalizeGroupPermission = (groups: Group[]): Group[] => {
  return groups.map((group) => ({
    ...group,
    name: GROUP_NAME_TEXT[group.name] as GroupName,
  }));
};

export const normalizeUserInfo = (users: User[]) => {
  return users.map((user) => ({
    ...user,
    groups: normalizeGroupPermission(user.groups),
  }));
};
